import { resolveEditorCapabilities } from '@wix/a11y-adapters';
import { AUTO_DOM_ORDER_DATE } from '../../../constants';
import { getIsLanguageDirectionMatchingDomDirection } from '../../../utils/get-is-language-direction-matching-dom-direction';
export function computeSiteDomOrderStatus(tools, _ref) {
  var _tools$logger;
  let {
    automaticDomOrderEnabled,
    isAutomaticallyCompleted,
    isManuallyCompleted,
    siteCreationDate,
    siteDomDirection,
    siteLanguage,
    editorType
  } = _ref;
  const siteCreatedAfterAutoDom = new Date(siteCreationDate) > AUTO_DOM_ORDER_DATE;
  const isLanguageAndDomDirectionMisaligned = !getIsLanguageDirectionMatchingDomDirection({
    siteDomDirection,
    siteLanguage
  });
  const odDomOrderPolicy = editorType !== undefined && resolveEditorCapabilities(editorType).odDomOrderPolicy;
  let domOrderStatus;

  // Note: The order of these conditions is important
  if (odDomOrderPolicy) {
    if (isLanguageAndDomDirectionMisaligned) {
      domOrderStatus = isManuallyCompleted ? 'passed' : 'failed';
    } else if (isManuallyCompleted && !isLanguageAndDomDirectionMisaligned) {
      domOrderStatus = 'not-applicable';
    } else if (isAutomaticallyCompleted && automaticDomOrderEnabled) {
      domOrderStatus = 'not-applicable';
    } else {
      domOrderStatus = 'not-applicable';
    } // ORIGINAL LOGIC FOR STUDIO & CLASSIC EDITOR
  } else {
    if (isManuallyCompleted) {
      domOrderStatus = 'passed';
    } else if (isLanguageAndDomDirectionMisaligned) {
      domOrderStatus = 'failed';
    } else if (editorType !== undefined && resolveEditorCapabilities(editorType).usesStaticClassicBreakpoints) {
      domOrderStatus = automaticDomOrderEnabled ? 'passed' : 'failed';
    } else if (siteCreatedAfterAutoDom) {
      domOrderStatus = automaticDomOrderEnabled ? 'passed' : 'failed';
    } else if (isAutomaticallyCompleted && automaticDomOrderEnabled) {
      domOrderStatus = 'passed';
    } else {
      domOrderStatus = 'failed';
    }
  }
  tools == null || (_tools$logger = tools.logger) == null || _tools$logger.info(`Running computeSiteDomOrderStatus`, {
    automaticDomOrderEnabled,
    domOrderStatus,
    editorType,
    isAutomaticallyCompleted,
    isLanguageAndDomDirectionMisaligned,
    isManuallyCompleted,
    odDomOrderPolicy,
    siteCreatedAfterAutoDom,
    siteCreationDate,
    siteDomDirection,
    siteLanguage
  });
  return domOrderStatus;
}
//# sourceMappingURL=compute-site-dom-order-status.js.map